'use client'
import * as React from 'react'
import * as Accordion from '@radix-ui/react-accordion'
import { tw } from 'utils/classnames'

import { ChevronDownIcon } from '../icons'

// eslint-disable-next-line no-barrel-files/no-barrel-files
// oxlint-disable-next-line cf-web/no-barrel-file
export { Root } from '@radix-ui/react-accordion'
// eslint-disable-next-line no-barrel-files/no-barrel-files
// oxlint-disable-next-line cf-web/no-barrel-file
export type { AccordionSingleProps, AccordionMultipleProps } from '@radix-ui/react-accordion'

export function Header(props: React.ComponentProps<typeof Accordion.Header>) {
  return <Accordion.Header {...props} />
}

export function Item(props: React.ComponentProps<typeof Accordion.Item>) {
  return <Accordion.Item {...props} className={tw('group/item', props.className)} />
}

export const Trigger = function Trigger({
  ref,
  children,
  icon,
  iconClassName,
  ...props
}: { icon?: React.JSX.Element; iconClassName?: string } & React.ComponentProps<
  typeof Accordion.Trigger
>) {
  return (
    <Accordion.Trigger
      {...props}
      ref={ref}
      className={tw(
        'group/trigger flex min-h-10 w-full items-center justify-between gap-2 rounded outline-none hover:text-gray-200 focus:text-gray-200',
        props.className,
      )}
    >
      {children}
      {icon ? (
        icon
      ) : (
        <ChevronDownIcon
          className={tw(
            "size-4 min-w-4 transition-transform group-data-[state='open']/trigger:rotate-180 text-legacy-cf-purple-100 shrink-0",
            iconClassName,
          )}
          aria-hidden
        />
      )}
    </Accordion.Trigger>
  )
}

export const Content = function Content({
  ref,
  ...props
}: React.ComponentProps<typeof Accordion.Content> & {
  ref?: React.RefObject<HTMLDivElement | null>
}) {
  return (
    <Accordion.Content
      {...props}
      ref={ref}
      className={tw(
        "data-[state='open']/item:animate-height-in",
        "data-[state='closed']/item:animate-height-out",
        'overflow-hidden',
        props.className,
      )}
    />
  )
}
